import { useQuery } from '@tanstack/react-query';
import apiService, { SystemCategory } from '../services/api';

export const useSystemCategories = () => {
  return useQuery<SystemCategory[], Error>({
    queryKey: ['systemCategories'],
    queryFn: apiService.getSystemCategories,
    staleTime: 1000 * 60 * 30, // 30 minutes - categories don't change often
    gcTime: 1000 * 60 * 60, // 1 hour
  });
};
